module.exports = __webpack_public_path__ + "assets/google-play-badge.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/google-play-badge.png
// module id = 429
// module chunks = 17